export const formName = 'payment'
export const sectionName = 'payment'
export const deliveryAddressSectionName = 'delivery'
